import parseCompareItems from './parseCompareItems.js';
import { compareItemsLSKey } from '../../../configuration/Configuration.js';

/** @typedef {import('./typedefs.js').CompareItems} CompareItems */

/** @returns {CompareItems} */
export default () => parseCompareItems(localStorage.getItem(compareItemsLSKey));
